import React, { useEffect } from 'react';
import './BarterKingDrawer.css';

export default function BarterKingDrawer({ open, onClose }) {
  // Close on ESC
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === 'Escape' && onClose?.();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="bkdr-overlay" role="dialog" aria-modal="true" aria-label="About Barter King">
      <div className="bkdr-scrim" onClick={onClose} />
      <div className="bkdr-sheet" tabIndex={-1}>
        <div className="bkdr-handle" />
        <div className="bkdr-header">
          <div className="bkdr-emoji" aria-hidden>👑</div>
          <div className="bkdr-title">Barter King</div>
          <button className="bkdr-close" onClick={onClose} aria-label="Close">✕</button>
        </div>

        <div className="bkdr-content">
          <p className="bkdr-lead">
            Barter King is the user who has moved the most Pi through BarterFi in the current reward period.
          </p>

          <ul className="bkdr-list">
            <li><b>What counts?</b> Tips, stakes, and marketplace payments sent in the app.</li>
            <li><b>Who gets it?</b> The #1 user on the leaderboard.</li>
            <li><b>How many winners?</b> Only one user can hold the crown at a time.</li>
            <li><b>How to climb?</b> Stay active and keep using Pi across the app.</li>
          </ul>

          <div className="bkdr-hint">
            The more Pi you use in BarterFi, the better your chances.
          </div>
        </div>
      </div>
    </div>
  );
}
